import React, { createContext, useContext, useState, useEffect } from 'react';
import { tiendasApi } from '../services/api';

const SucursalContext = createContext();

export const useSucursal = () => {
  const context = useContext(SucursalContext);
  if (!context) {
    throw new Error('useSucursal debe usarse dentro de SucursalProvider');
  }
  return context;
};

export const SucursalProvider = ({ children }) => {
  const [sucursales, setSucursales] = useState([]);
  const [sucursalActual, setSucursalActual] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSucursales();
  }, []);

  const loadSucursales = async () => {
    try {
      const response = await tiendasApi.getAll();
      const tiendas = response.data || [];
      setSucursales(tiendas);

      // Cargar sucursal guardada en localStorage o usar "todas"
      const savedSucursal = localStorage.getItem('sucursal_actual');
      if (savedSucursal && savedSucursal !== 'todas') {
        const found = tiendas.find(t => t.id === parseInt(savedSucursal));
        setSucursalActual(found || null);
      } else {
        setSucursalActual(null); // null = todas las sucursales
      }
    } catch (error) {
      console.error('Error cargando sucursales:', error);
    } finally {
      setLoading(false);
    }
  };

  const cambiarSucursal = (tiendaId) => {
    if (tiendaId === 'todas' || tiendaId === null) {
      setSucursalActual(null);
      localStorage.setItem('sucursal_actual', 'todas');
    } else {
      const tienda = sucursales.find(t => t.id === parseInt(tiendaId));
      setSucursalActual(tienda || null);
      localStorage.setItem('sucursal_actual', tiendaId.toString());
    }
  };

  const getSucursalId = () => {
    return sucursalActual ? sucursalActual.id : null;
  };

  const getSucursalNombre = () => {
    return sucursalActual ? sucursalActual.nombre : 'Todas las Sucursales';
  };

  const value = {
    sucursales,
    sucursalActual,
    loading,
    cambiarSucursal,
    getSucursalId,
    getSucursalNombre,
    refreshSucursales: loadSucursales
  };

  return (
    <SucursalContext.Provider value={value}>
      {children}
    </SucursalContext.Provider>
  );
};

export default SucursalContext;
